// extracted by mini-css-extract-plugin
export default {"bagWrapper":"e32mZFt2vq17cxKCkszsV","bagTitle":"_3SVWrszhAqEEhBObvX2Ut_","bagItems":"_2C27nA3Xdr6nns0ZIaManU","bagTotal":"_3S2iqNggJhjs11Toa8XitS","bagMenu":"QYI7u-29jBMrz7xEagDdM"};